export const FRIENDLY_CLR_DATA_TYPE_LABELS = Object.freeze({
  "System.Boolean": "Boolean",
  "System.Byte": "Byte",
  "System.Byte[]": "Byte Array",
  "System.DateOnly": "Date",
  "System.DateTime": "Date Time",
  "System.DateTimeOffset": "Date Time with Offset",
  "System.Decimal": "Decimal",
  "System.Double": "Double",
  "System.Guid": "Guid",
  "System.Int16": "Short",
  "System.Int32": "Integer",
  "System.Int64": "Long",
  "System.Object": "Object",
  "System.Single": "Float",
  "System.String": "String",
  "System.String[]": "String List",
  "System.TimeOnly": "Time",
  "System.TimeSpan": "Time Span"
});

const normalizeTypeValue = (value) => String(value ?? "").trim();

export const formatFieldDataTypeName = (value, fallback = "") => {
  const storedType = normalizeTypeValue(value);
  if (!storedType) return fallback;

  const friendlyLabel = FRIENDLY_CLR_DATA_TYPE_LABELS[storedType];
  if (friendlyLabel) return friendlyLabel;

  if (/^System\.Collections\.Generic\.Dictionary/i.test(storedType)) return "JSON Object";
  if (/^System\.Collections\.Generic\.(?:List|IList|IEnumerable|ICollection)/i.test(storedType)) {
    return /System\.String/i.test(storedType) ? "String List" : "List";
  }

  return storedType.replace(/^System\./i, "") || fallback;
};

export const getFieldDataTypeDisplayLabel = (field, fallback = "Unknown") => {
  const raw = field?.raw || {};
  const systemDataType =
    field?.SystemDataType ??
    field?.systemDataType ??
    raw?.SystemDataType ??
    raw?.systemDataType;
  const dataTypeName =
    field?.DataTypeName ??
    field?.dataTypeName ??
    raw?.DataTypeName ??
    raw?.dataTypeName ??
    field?.DataType?.DisplayName ??
    field?.DataType?.Name ??
    raw?.DataType?.DisplayName ??
    raw?.DataType?.Name;

  if (
    normalizeTypeValue(systemDataType).toUpperCase() === "JSON" &&
    normalizeTypeValue(dataTypeName).toLowerCase() === "system.object"
  ) {
    return "JSON Object";
  }

  return formatFieldDataTypeName(systemDataType || dataTypeName || field?.DataTypeId || field?.dataTypeId, fallback);
};
